import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-advance-pay',
  templateUrl: './advance-pay.component.html',
  styleUrls: ['./advance-pay.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancePayComponent {
  public tarjetaActiva: string | null = null;
  constructor(
    private readonly dialogRef: MatDialogRef<AdvancePayComponent>,
    @Inject(MAT_DIALOG_DATA) private inputs: {
      tarjetas: Array<any>,
      saveTarjetas: Array<any>
    }
  ) {}

  public close() {
    this.dialogRef.close(null);
  }

  public submit(): void {
    this.dialogRef.close(this.tarjetaActiva);
  }

  public get tarjetas() {
    return this.inputs?.tarjetas ?? []
  }

  public getIsPrincipal(id: string) {
    return this.inputs.saveTarjetas.some((item) => item.stripe_id === id && item.principal == 1);
  }
}